import { environmentDefaults } from './environment-defaults';
import { API_ENDPOINTS } from './api-endpoints';
import * as defaultsDeep from 'lodash.defaultsdeep';
const override = {
  DESKING: API_ENDPOINTS.DESKING.E2E,
  hostname: API_ENDPOINTS.HOSTNAME.E2E,
  production: API_ENDPOINTS.ISPRODUCTION.E2E,
  //AOT: AOT,
  ENV: API_ENDPOINTS.ENV.E2E, //(PROD || TEST || QA || E2E || STAGE) ? JSON.stringify('production') : JSON.stringify('development'), 
  /**
  * specifies which @ngrx dev tools will be available when you build and load
  * your app in dev mode. Options are: monitor | logger | both | none
  */
  STORE_DEV_TOOLS: API_ENDPOINTS.STORE_DEV_TOOLS.E2E,
  MIN_LOG_LEVEL: API_ENDPOINTS.MIN_LOG_LEVEL.E2E,
  ACTUAL_ENV: API_ENDPOINTS.ACTUAL_ENV.E2E,  //  PROD ? JSON.stringify('production') : QA ? JSON.stringify('qa') : TEST ? JSON.stringify('test') : E2E ? JSON.stringify('e2e') : STAGE ? JSON.stringify('stage') : JSON.stringify('development'),
  EFC_URL: API_ENDPOINTS.EFC_URL.E2E,
  AUTH_BASE_URL: API_ENDPOINTS.AUTH_BASE_URL.E2E,
  DIS_URL: API_ENDPOINTS.DIS_URL.E2E,
  BASE_SERVICE_URL: API_ENDPOINTS.BASE_SERVICE_URL.E2E,
  PRESOLD_BASE_SERVICE_URL: API_ENDPOINTS.PRESOLD_BASE_SERVICE_URL.E2E,
  USED_VEHICLE_BASE_SERVICE_URL: API_ENDPOINTS.USED_VEHICLE_BASE_SERVICE_URL.E2E,
  POST_LOGOUT_REDIRECT_URL: API_ENDPOINTS.POST_LOGOUT_REDIRECT_URL.E2E,
  SILENT_REDIRECT_URL: API_ENDPOINTS.SILENT_REDIRECT_URL.E2E,
  AUTHORIZATION_ENDPOINT: API_ENDPOINTS.AUTHORIZATION_ENDPOINT.E2E,
  ISSUER: API_ENDPOINTS.ISSUER.E2E,
  JWTURI: API_ENDPOINTS.JWTURI.E2E,
  AUTHORITY: API_ENDPOINTS.AUTHORIZATION_ENDPOINT.E2E,
  CLIENT_ID: API_ENDPOINTS.CLIENT_ID.E2E,
  CONSUMER_PREVIEW_ENDPOINT: API_ENDPOINTS.CONSUMER_PREVIEW_ENDPOINT.E2E,
  MST_BASE_SERVICE_URL: API_ENDPOINTS.MST_BASE_SERVICE_URL.E2E,
  DG_BASE_SERVICE_URL: API_ENDPOINTS.DG_BASE_SERVICE_URL.E2E,
  SOCKET_ENDPOINT: API_ENDPOINTS.SOCKET_ENDPOINT.E2E,
  VSPEC_GUEST_PORTAL: API_ENDPOINTS.VSPEC_GUEST_PORTAL.E2E,
  CREDIT_APP_URL: API_ENDPOINTS.CREDIT_APP_URL.E2E,
  ENGAGE_MATERIAL_URL: API_ENDPOINTS.ENGAGE_MATERIAL_URL.E2E,
  MST_CONSOLE: API_ENDPOINTS.MST_CONSOLE.E2E,
  AUTH_AUTHORITY: API_ENDPOINTS.AUTH_AUTHORITY.E2E,
  SIGNAL_URL: API_ENDPOINTS.SIGNAL.E2E,
  TRADE_SIGNAL_URL: API_ENDPOINTS.TRADE_SIGNAL_ENDPOINT.E2E
};

export const environment = defaultsDeep(override, environmentDefaults);
